<template>
    <div class="bd-map row align-items-center">
        <div class="col-lg-7">
            <div v-if="selectedMapDivision" class="individual_division">
                <button @click.prevent="selectedMapDivision = null" class="back-btn">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19.6189 4.39526C19.873 4.65876 20 4.97075 20 5.33123C20 5.691 19.873 6.00264 19.6189 6.26614L12.1755 13.9868L19.6443 21.7339C19.8814 21.9798 20 22.2872 20 22.6561C20 23.025 19.873 23.3412 19.6189 23.6047C19.3649 23.8682 19.0641 24 18.7166 24C18.3697 24 18.0693 23.8682 17.8152 23.6047L9.27945 14.7246C9.17783 14.6192 9.10568 14.5051 9.063 14.3821C9.021 14.2591 9 14.1274 9 13.9868C9 13.8463 9.021 13.7145 9.063 13.5916C9.10568 13.4686 9.17783 13.3544 9.27945 13.249L17.8406 4.36891C18.0778 4.12297 18.3697 4 18.7166 4C19.0641 4 19.3649 4.13175 19.6189 4.39526Z"
                            fill="#662D91" />
                    </svg>
                    {{ __('Go Back') }}
                </button>
                <component :is="`${selectedMapDivision.name}-map`"
                    @mouseenter:district="handleMouseenterOnDistrict"
                    @mouseleave:district="handleMouseleaveOnDistrict" />
                <div class="district_hover_output hide">
                    <div>
                        <h1 class="title">
                            {{ locale_attr(selectedDistrict, 'name_{lang}') }}
                            {{ __('District') }}
                        </h1>
                        <Spinner v-if="loadingUpazilaWiseStats" color="white" />
                        <table v-else-if="hoveredDistrictUpazilaWiseStats.length" class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{{ __('Upazila') }}</th>
                                    <th>{{ __('Total') }} {{ __('Teachers') }}</th>
                                    <th>{{ __('Total') }} {{ __('Institution') }}</th>
                                    <th>{{ __('Total') }} {{ __('Contents') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(obj, i) in hoveredDistrictUpazilaWiseStats" :key="i">
                                    <td>{{ locale_attr(obj, 'upazila_name_{lang}') }}</td>
                                    <td>{{ en_to_bn(obj.users_count) }}</td>
                                    <td>{{ en_to_bn(obj.institutions_count) }}</td>
                                    <td>{{ en_to_bn(obj.contents_count) }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else class="text-center pb-3">{{ __('No data found') }}</div>
                    </div>
                </div>
            </div>
            <div v-else class="division_parent">
                <BangladeshMap @click:division="division => selectedMapDivision = division" />
                <div class="division_lists">
                    <p v-for="division in divisions" :key="division.id">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="16.9405" height="16.9405" :fill="divisionsColor[division.id]" />
                        </svg>
                        {{ locale_attr(division, 'name_{lang}') }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <div class="card district_data_card">
                <template v-if="selectedDivision">
                    <div class="section-title">
                        {{ locale_attr(selectedDivision, 'name_{lang}') }}
                        {{ __('Division') }}
                    </div>
                    <Spinner v-if="loadingDistrictWiseUserCount" min-height="300px" />
                    <div v-else-if="districtWiseUserCount.length" class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr class="text-center">
                                    <th>{{ __('District') }}</th>
                                    <th></th>
                                    <th>{{ __('Male') }}</th>
                                    <th>{{ __('Female') }}</th>
                                    <th>{{ __('Total') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(obj, i) in districtWiseUserCount" class="text-center" :key="i">
                                    <td>{{ en_to_bn(i + 1) }}</td>
                                    <td class="text-start">
                                        {{ locale_attr(obj, 'district_name_{lang}g') }}
                                    </td>
                                    <td>{{ en_to_bn(obj.male_count) }}</td>
                                    <td>{{ en_to_bn(obj.female_count) }}</td>
                                    <td>{{ en_to_bn(obj.total_count) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="text-center pb-4">{{ __('No data found') }}</div>
                </template>
                <template v-else>
                    <div class="section-title">{{ __('Division') }}</div>
                    <Spinner v-if="loadingDivisionWiseUserCount" min-height="300px" />
                    <div v-else-if="divisionWiseUserCount.length" class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr class="text-center">
                                    <th>{{ __('Division') }}</th>
                                    <th></th>
                                    <th>{{ __('Male') }}</th>
                                    <th>{{ __('Female') }}</th>
                                    <th>{{ __('Total') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(obj, i) in divisionWiseUserCount" class="text-center" :key="i">
                                    <td>{{ en_to_bn(i + 1) }}</td>
                                    <td class="text-start">
                                        {{ locale_attr(obj, 'division_name_{lang}g') }}
                                    </td>
                                    <td>{{ en_to_bn(obj.male_count) }}</td>
                                    <td>{{ en_to_bn(obj.female_count) }}</td>
                                    <td>{{ en_to_bn(obj.total_count) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="text-center pb-4">{{ __('No data found') }}</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import BangladeshMap from '../../components/bd_map/Map';
import RajshahiMap from '../../components/bd_map/divisions/Rajshahi';
import RangpurMap from '../../components/bd_map/divisions/Rangpur';
import DhakaMap from '../../components/bd_map/divisions/Dhaka';
import SylhetMap from '../../components/bd_map/divisions/Sylhet';
import ChattogramMap from '../../components/bd_map/divisions/Chattogram';
import MymensinghMap from '../../components/bd_map/divisions/Mymensingh';
import KhulnaMap from '../../components/bd_map/divisions/Khulna';
import BarishalMap from '../../components/bd_map/divisions/Barishal';
import Spinner from '../../components/Spinner';

export default {
    components: {
        BangladeshMap,
        RajshahiMap,
        RangpurMap,
        DhakaMap,
        SylhetMap,
        ChattogramMap,
        MymensinghMap,
        KhulnaMap,
        BarishalMap,
        Spinner,
    },

    data() {
        return {
            divisions: [],
            divisionsColor: {
                1: '#89B8E4',
                2: '#7FC94D',
                3: '#8EC79A',
                4: '#FFEB64',
                5: '#BACE6B',
                6: '#F8A758',
                7: '#AC8FC7',
                9: '#93DCCF',
            },
            selectedMapDivision: null,
            divisionWiseUserCount: [],
            loadingDivisionWiseUserCount: false,
            upazilaWiseStats: null,
            loadingUpazilaWiseStats: false,
            districtWiseUserCount: [],
            loadingDistrictWiseUserCount: false,
            hoveredDistrictId: null,
            districts: [],
        }
    },

    watch: {
        selectedMapDivision: function () {
            this.fetchDistricts();
            this.fetchDistrictWiseUserCount();
            this.fetchUpazilaWiseStats();
        },
    },

    computed: {
        selectedDivision() {
            if (!this.divisions.length || !this.selectedMapDivision) return;
            return this.divisions.find(division => division.id === this.selectedMapDivision.id);
        },
        selectedDistrict() {
            if (!this.districts.length || !this.hoveredDistrictId) return;
            return this.districts.find(district => district.id === this.hoveredDistrictId);
        },
        hoveredDistrictUpazilaWiseStats() {
            if (!this.upazilaWiseStats || !this.hoveredDistrictId) return [];
            return this.upazilaWiseStats[this.hoveredDistrictId] || [];
        },
    },

    mounted() {
        this.observe_visibility(this.$el, () => {
            this.fetchDivisions();
            this.fetchDivisionWiseUserCount();
            this.initDistrictHoverPopup();
        });
    },

    methods: {
        fetchDivisions() {
            axios.get('/api/divisions')
                .then(({ data }) => this.divisions = data.data)
                .catch(console.error);
        },

        fetchDistricts() {
            this.districts = [];
            if (!this.selectedMapDivision) return;
            const params = { division_id: this.selectedMapDivision.id };
            axios.get('/api/districts', { params })
                .then(({ data }) => this.districts = data.data)
                .catch(console.error);
        },

        async fetchDivisionWiseUserCount() {
            this.divisionWiseUserCount = [];
            this.loadingDivisionWiseUserCount = true;
            await axios.get('/dashboard/division-wise-user-count')
                .then(({ data }) => this.divisionWiseUserCount = data.counts)
                .catch(console.error);

            this.loadingDivisionWiseUserCount = false;
        },

        async fetchDistrictWiseUserCount() {
            this.districtWiseUserCount = [];
            if (!this.selectedMapDivision) return;
            this.loadingDistrictWiseUserCount = true;
            const params = { division_id: this.selectedMapDivision.id };
            await axios.get('/dashboard/district-wise-user-count', { params })
                .then(({ data }) => this.districtWiseUserCount = data.counts)
                .catch(console.error);

            this.loadingDistrictWiseUserCount = false;
        },

        async fetchUpazilaWiseStats() {
            if (!this.selectedMapDivision) return;
            this.loadingUpazilaWiseStats = true;
            const params = { division_id: this.selectedMapDivision.id };
            await axios.get('/dashboard/upazila-wise-stats', { params })
                .then(({ data }) => this.upazilaWiseStats = data.stats)
                .catch(console.error);

            this.loadingUpazilaWiseStats = false;
        },

        async handleMouseenterOnDistrict({ id }) {
            this.hoveredDistrictId = id;
        },

        handleMouseleaveOnDistrict() {
            this.hoveredDistrictId = null;
        },

        initDistrictHoverPopup() {
            const hoverableDivision = '.individual_division svg g';
            const outputDiv = '.district_hover_output';

            $(document).on('mouseenter', hoverableDivision, function (e) {
                let { top, left } = $(e.target.closest('g')).offset();
                const windowWidth = $(window).width();
                const hoverItemWidth = $(outputDiv).width() + 8;
                const leftOffset = Math.ceil(left) + hoverItemWidth;

                $(outputDiv).removeClass('hide');
                $(outputDiv).addClass('visible');

                // set top position
                if ($(this).hasClass('jashore')) {
                    $(outputDiv).css({ "--top": Math.ceil(top + 500) + 'px' });
                } else {
                    $(outputDiv).css({ "--top": Math.ceil(top) + 'px' });
                }

                // set left position
                if (leftOffset > windowWidth) {
                    const leftPosition = windowWidth - hoverItemWidth - 15;
                    $(outputDiv).css({ "--left": leftPosition + 'px' });
                } else {
                    $(outputDiv).css({ "--left": Math.ceil(left) + 'px' });
                }
            });

            $(document).on('mouseleave', hoverableDivision, function (e) {
                $(outputDiv).addClass('hide');
                $(outputDiv).removeClass('visible');
            });
        },
    },
}
</script>